import { type MRT_Localization } from "material-react-table";

export const MRT_Localization_PA: MRT_Localization = {
  language: "pa",
  actions: "ਕਾਰਵਾਈਆਂ",
  and: "ਅਤੇ",
  cancel: "ਰੱਦ ਕਰੋ",
  changeFilterMode: "ਫਿਲਟਰ ਮੋਡ ਬਦਲੋ",
  changeSearchMode: "ਖੋਜ ਮੋਡ ਬਦਲੋ",
  clearFilter: "ਫਿਲਟਰ ਸਾਫ਼ ਕਰੋ",
  clearSearch: "ਖੋਜ ਸਾਫ਼ ਕਰੋ",
  clearSelection: "ਚੋਣ ਸਾਫ਼ ਕਰੋ",
  clearSort: "ਸੌਰਟ ਸਾਫ਼ ਕਰੋ",
  clickToCopy: "ਕਾਪੀ ਕਰਨ ਲਈ ਕਲਿਕ ਕਰੋ",
  copy: "ਕਾਪੀ",
  collapse: "ਸੁੰਗੜੋ",
  collapseAll: "ਸਭ ਸੁੰਗੜੋ",
  columnActions: "ਕਾਲਮ ਕਾਰਵਾਈਆਂ",
  copiedToClipboard: "ਕਲਿਪਬੋਰਡ ਵਿੱਚ ਕਾਪੀ ਕੀਤਾ ਗਿਆ",
  dropToGroupBy: "ਗਰੁੱਪ ਕਰਨ ਲਈ {column} 'ਤੇ ਡ੍ਰੌਪ ਕਰੋ",
  edit: "ਸੰਪਾਦਨ",
  expand: "ਵਿਸਤਾਰ",
  expandAll: "ਸਭ ਵਿਸਤਾਰ",
  filterArrIncludes: "ਸ਼ਾਮਲ ਕਰਦਾ ਹੈ",
  filterArrIncludesAll: "ਸਭ ਸ਼ਾਮਲ ਕਰਦਾ ਹੈ",
  filterArrIncludesSome: "ਸ਼ਾਮਲ ਕਰਦਾ ਹੈ",
  filterBetween: "ਵਿਚਕਾਰ",
  filterBetweenInclusive: "ਸ਼ਾਮਲ ਵਿਚਕਾਰ",
  filterByColumn: "{column} ਦੁਆਰਾ ਫਿਲਟਰ ਕਰੋ",
  filterContains: "ਸ਼ਾਮਲ ਕਰਦਾ ਹੈ",
  filterEmpty: "ਖਾਲੀ",
  filterEndsWith: "ਨਾਲ ਖਤਮ ਹੁੰਦਾ ਹੈ",
  filterEquals: "ਬਰਾਬਰ",
  filterEqualsString: "ਬਰਾਬਰ",
  filterFuzzy: "ਫਜ਼ੀ",
  filterGreaterThan: "ਤੋਂ ਵੱਡਾ",
  filterGreaterThanOrEqualTo: "ਤੋਂ ਵੱਡਾ ਜਾਂ ਬਰਾਬਰ",
  filterInNumberRange: "ਵਿਚਕਾਰ",
  filterIncludesString: "ਸ਼ਾਮਲ ਕਰਦਾ ਹੈ",
  filterIncludesStringSensitive: "ਸ਼ਾਮਲ ਕਰਦਾ ਹੈ",
  filterLessThan: "ਤੋਂ ਛੋਟਾ",
  filterLessThanOrEqualTo: "ਤੋਂ ਛੋਟਾ ਜਾਂ ਬਰਾਬਰ",
  filterMode: "ਫਿਲਟਰ ਮੋਡ: {filterType}",
  filterNotEmpty: "ਖਾਲੀ ਨਹੀਂ",
  filterNotEquals: "ਬਰਾਬਰ ਨਹੀਂ",
  filterStartsWith: "ਨਾਲ ਸ਼ੁਰੂ ਹੁੰਦਾ ਹੈ",
  filterWeakEquals: "ਬਰਾਬਰ",
  filteringByColumn: "{column} ਦੁਆਰਾ ਫਿਲਟਰਿੰਗ - {filterType} {filterValue}",
  goToFirstPage: "ਪਹਿਲੇ ਪੰਨੇ 'ਤੇ ਜਾਓ",
  goToLastPage: "ਆਖਰੀ ਪੰਨੇ 'ਤੇ ਜਾਓ",
  goToNextPage: "ਅਗਲੇ ਪੰਨੇ 'ਤੇ ਜਾਓ",
  goToPreviousPage: "ਪਿਛਲੇ ਪੰਨੇ 'ਤੇ ਜਾਓ",
  grab: "ਫੜੋ",
  groupByColumn: "{column} ਦੁਆਰਾ ਗਰੁੱਪ ਕਰੋ",
  groupedBy: "ਦੁਆਰਾ ਗਰੁੱਪ ਕੀਤਾ ਗਿਆ ",
  hideAll: "ਸਭ ਲੁਕਾਓ",
  hideColumn: "{column} ਕਾਲਮ ਲੁਕਾਓ",
  max: "ਵੱਧ ਤੋਂ ਵੱਧ",
  min: "ਘੱਟ ਤੋਂ ਘੱਟ",
  move: "ਮੂਵ",
  noRecordsToDisplay: "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਰਿਕਾਰਡ ਨਹੀਂ",
  noResultsFound: "ਕੋਈ ਨਤੀਜੇ ਨਹੀਂ ਮਿਲੇ",
  of: "ਦਾ",
  or: "ਜਾਂ",
  pin: "ਪਿੰਨ ਕਰੋ",
  pinToLeft: "ਖੱਬੇ ਪਿੰਨ ਕਰੋ",
  pinToRight: "ਸੱਜੇ ਪਿੰਨ ਕਰੋ",
  resetColumnSize: "ਕਾਲਮ ਆਕਾਰ ਰੀਸੈੱਟ ਕਰੋ",
  resetOrder: "ਕ੍ਰਮ ਰੀਸੈੱਟ ਕਰੋ",
  rowActions: "ਰੋ ਕਾਰਵਾਈਆਂ",
  rowNumber: "#",
  rowNumbers: "ਰੋ ਨੰਬਰ",
  rowsPerPage: "ਪ੍ਰਤੀ ਪੰਨਾ ਰੋ",
  save: "ਸੇਵ",
  search: "ਖੋਜੋ",
  selectedCountOfRowCountRowsSelected:
    "{selectedCount} ਵਿੱਚੋਂ {rowCount} ਰੋ(ਜ਼) ਚੁਣੇ ਗਏ",
  select: "ਚੁਣੋ",
  showAll: "ਸਭ ਦਿਖਾਓ",
  showAllColumns: "ਸਭ ਕਾਲਮ ਦਿਖਾਓ",
  showHideColumns: "ਕਾਲਮ ਦਿਖਾਓ/ਲੁਕਾਓ",
  showHideFilters: "ਫਿਲਟਰ ਦਿਖਾਓ/ਲੁਕਾਓ",
  showHideSearch: "ਖੋਜ ਦਿਖਾਓ/ਲੁਕਾਓ",
  sortByColumnAsc: "{column} ਦੁਆਰਾ ਚੜ੍ਹਦੇ ਕ੍ਰਮ ਵਿੱਚ ਸੌਰਟ ਕਰੋ",
  sortByColumnDesc: "{column} ਦੁਆਰਾ ਉਤਰਦੇ ਕ੍ਰਮ ਵਿੱਚ ਸੌਰਟ ਕਰੋ",
  sortedByColumnAsc: "{column} ਦੁਆਰਾ ਚੜ੍ਹਦੇ ਕ੍ਰਮ ਵਿੱਚ ਸੌਰਟ ਕੀਤਾ ਗਿਆ",
  sortedByColumnDesc: "{column} ਦੁਆਰਾ ਉਤਰਦੇ ਕ੍ਰਮ ਵਿੱਚ ਸੌਰਟ ਕੀਤਾ ਗਿਆ",
  thenBy: ", ਫਿਰ ",
  toggleDensity: "ਘਣਤਾ ਟੌਗਲ ਕਰੋ",
  toggleFullScreen: "ਪੂਰੀ ਸਕ੍ਰੀਨ ਟੌਗਲ ਕਰੋ",
  toggleSelectAll: "ਸਭ ਚੋਣ ਟੌਗਲ ਕਰੋ",
  toggleSelectRow: "ਰੋ ਚੋਣ ਟੌਗਲ ਕਰੋ",
  toggleVisibility: "ਦ੍ਰਿਸ਼ਟੀ ਟੌਗਲ ਕਰੋ",
  ungroupByColumn: "{column} ਦੁਆਰਾ ਗਰੁੱਪ ਰੱਦ ਕਰੋ",
  unpin: "ਅਨਪਿੰਨ ਕਰੋ",
  unpinAll: "ਸਭ ਅਨਪਿੰਨ ਕਰੋ",
};
